// Definição para o modal de busca de Grupos Empresariais
// Variação de parceiroSearch para busca de Grupos
// Factory function - recebe idEmpresa como parâmetro

export const criarConfigBuscaParceiroGrupo = (idOrganizacao) => ({
  label: 'Grupo Empresarial',
  placeholder: 'Nome ou Documento...',
  titulo: 'Pesquisar Grupo Empresa',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  camposFiltro: [
    { model: 'busca', label: 'Nome ou Documento', tipo: 'text' },
    { model: 'isGrupoEmpresa', label: 'Grupo', tipo: 'hidden', value: true },
    { model: 'idOrganizacao', label: 'Empresa', tipo: 'hidden', value: idOrganizacao }
  ],
  colunasGrid: [
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '70%' },
    { header: 'Documento', dataField: 'documento', width: '30%' }
  ]
})
